import { FunctionComponent } from 'react';
import './styles/EnrolmentComplete.scss';

import { Button } from './core/Button';
import { SCHEDULE_MODE } from '../models';

interface IEnrolmentCompleteProps {
  onEnrolAnotherStudent: () => void;
  mode: SCHEDULE_MODE;
}
export const EnrolmentComplete: FunctionComponent<IEnrolmentCompleteProps> = (props: IEnrolmentCompleteProps) => {

  const { onEnrolAnotherStudent, mode } = props;

  return (
    <div className='ppa-schedule-enrolment-complete'>
      <h1>
        {mode === SCHEDULE_MODE.TRIAL ? 'Thank you for your trial registration!' : 'Thank you for enrolling with us!'} ✨
      </h1>

      <h4>
        {mode === SCHEDULE_MODE.TRIAL ? 'You will receive an email shortly with instructions' : 'We are currently processing your enrolment and will send you payment instructions within the next two working days'} 😊
      </h4>

      <Button onClick={onEnrolAnotherStudent}>
        {mode === SCHEDULE_MODE.TRIAL ? 'Register Another Student for a Trial' : 'Enrol Another Student'}
      </Button>
    </div>
  )
}